import {
  FILTER_KEY_TYPES_SLUGS,
  FILTER_KEY_TYPES_SLUGS_ARR,
  FILTER_TYPES_OPTIONS,
} from '../../constants/filters-constants';

export const filterFieldFormat = (string) => {
  return string ? decodeURIComponent(string)?.replaceAll('%20', ' ') : '';
};

export const formatOptionsForSelect = ({ list = [], setAsSlug = false, searchType = null, useSlug = false }) => {
  return list?.map((item) => {
    if (typeof item === 'string') {
      return {
        value: item,
        label: item,
        name: item,
        slug: item,
        id: item,
      };
    }
    return {
      ...item,
      value: setAsSlug ? item?.slug : (item?.id ?? item?.name),
      label:
        searchType === 'admin_users' ? `${item?.name} (${item?.email})` : (item?.name ?? item?.title ?? item?.value),
      name: item?.name ?? item?.title ?? item?.value,
      slug: setAsSlug || useSlug ? item?.slug : item?.id,
    };
  });
};

export const formatValueForSelect = ({ obj = null, key = 'name' }) => {
  return obj ? { ...obj, label: obj?.[key] } : null;
};

export const mapQueryStringToFilterObject = (search, cb = () => {}, setFilterChips) => {
  const queryObj = {},
    queryString = search?.replace(/%27/g, "'").split('?')[1];
  if (queryString) {
    const items = queryString.split('&');
    for (let item of items) {
      if (item.split('=')[0] !== 'widget_for') {
        const key = item.split('=')[0],
          value = item.split('=')[1];
        cb(key, filterFieldFormat(value));
        if (key && value) {
          if (queryObj[key]) {
            queryObj[key] += ',' + filterFieldFormat(value);
          } else {
            queryObj[key] = filterFieldFormat(value);
          }
        }
      }
    }
  } else {
    !!setFilterChips && setFilterChips(null);
  }
  return { queryObj };
};

export const convertQueryObjToString = (obj, encode = false, seperate = true) => {
  let keys = Object.keys(obj);
  if (keys?.length) {
    return keys
      .map((key) =>
        typeof obj[key] !== 'number' && obj[key]?.indexOf(',') !== -1 && seperate
          ? obj[key]
              ?.split(',')
              .map((e) => key + '=' + (encode ? encodeURIComponent(e) : e))
              .join('&')
          : obj[key]
            ? key + '=' + (encode ? encodeURIComponent(obj[key]) : obj[key])
            : '',
      )
      ?.filter((item) => !!item)
      ?.join('&');
  } else {
    return '';
  }
};

export const createQueryParam = (paramKey, paramValue) => `${paramKey}=${paramValue || ''}`;

export const appendParamsToQueryString = (paramKey, paramValue, queryString) => {
  const queryParam = `${queryString ? '&' : '?'}${createQueryParam(paramKey, paramValue)}`;
  const newQueryString = queryString + queryParam;
  return newQueryString;
};

export const getQueryString = (filters = {}, noStart = false, seperate = true) => {
  let queryString = '';
  if (filters) {
    queryString = `${noStart ? '&' : '?'}` + convertQueryObjToString(filters, true, seperate);
  }
  return queryString;
};

export const getFiltersArray = (filtersList) => {
  const advancedFilters = [];
  const filters = [];
  filtersList.forEach((filter) => {
    if (!filter?.show) return;
    if (filter.isAdvancedFilter) {
      advancedFilters.push(filter);
    } else {
      filters.push(filter);
    }
  });

  return { filters, advancedFilters };
};

export const isFilterable = (activeColumns, key) => activeColumns?.find((col) => col?.sortfield === key)?.filterable;


const RANSACK_PREDICATES = [
  'not_null',
  'not_eq',
  'not_in',
  'not_cont',
  'gteq',
  'lteq',
  'cont',
  'matches',
  'present',
  'blank',
  'null',
  'true',
  'false',
  'gt',
  'lt',
  'eq',
  'in',
];

export const getColumnByFilterKey = (activeColumns = [], filterKey = '') => {
  if (!activeColumns?.length || !filterKey) return null;
  const inner = filterKey.match(/\[([^\]]+)\]/)?.[1] || filterKey;
  const candidates = new Set([inner, inner.replace(/\.id$/, '')]);

  const pred = RANSACK_PREDICATES.find((p) => inner.endsWith(`_${p}`));
  if (pred) {
    const base = inner.slice(0, -(pred.length + 1));
    candidates.add(base);
    candidates.add(base.replace(/_id$/, ''));
  }

  const list = [...candidates];
  return activeColumns.find((col) => list.includes(col?.key) || list.includes(col?.sortfield)) || null;
};

export const getFilterDescription = (activeColumns, filterKey) =>
  getColumnByFilterKey(activeColumns, filterKey)?.description || '';

export const showResetButton = (location) => {
  // Counts the unique keys from location.search
  const { queryObj } = mapQueryStringToFilterObject(location.search);
  const keys = [];

  Object.keys(queryObj).forEach((key) => {
    key.split('[').map((item) => {
      if (!item.includes('lte') && !item.includes('gte')) {
        keys.push(item);
      }
    });
  });
  const uniqueKeys = new Set(keys.filter((item) => item.length > 1));
  return uniqueKeys.size > 1;
};

export const findQuickLink = ({ location, quickLinks }) => {
  if (!location?.search || !quickLinks?.length > 0) return null;

  return quickLinks?.find((link) => link?.body === `${location?.pathname}${location?.search}`);
};

export const removeChildFilter = (baseList, parentSearchKey, obj, parentValue, setSlugAsKey) => {
  const index = baseList?.findIndex((e) => e?.key === parentSearchKey);
  if (!baseList[index]?.child || !baseList[index]?.child?.length) return;

  baseList[index].child.forEach((childFilterKey) => {
    if (childFilterKey) {
      const childFiltersToDelete = baseList
        ?.find((e) => e.key === childFilterKey)
        ?.list?.filter((e) => e.parentId && !e.header && e.parentId.toString() === parentValue.toString());

      childFiltersToDelete &&
        childFiltersToDelete.forEach((e) => {
          removeChildFilter(baseList, childFilterKey, obj, setSlugAsKey ? e?.slug : e?.id, setSlugAsKey);
          removeFilter(obj, childFilterKey, setSlugAsKey ? e?.slug : e?.id);
        });
    }
  });
};

export const removeFilter = (obj, searchKey, value) => {
  if (obj[searchKey]) {
    const array = obj[searchKey].split(',');
    const index = array.indexOf(value.toString());
    if (index > -1) {
      if (array.length > 1) {
        array.splice(index, 1);
        obj[searchKey] = array.join(',');
      } else {
        delete obj[searchKey];
      }
    }
  }
};

export const removeFilterOnDemand = (obj, searchKey) => {
  if (obj[searchKey]) {
    if (searchKey.includes('[lte]')) {
      delete obj[searchKey];
      delete obj[searchKey.replace('[lte]', '[gte]')];
    } else if (searchKey.includes('[gte]')) {
      delete obj[searchKey];
      delete obj[searchKey.replace('[gte]', '[lte]')];
    }
    if (obj.hasOwnProperty(searchKey)) {
      delete obj[searchKey];
    }
  }
};

// ---------------------- Date Filter ------------------------

export const getDateKeys = (item = {}) => {
  const keys = {};
  if (item?.customKeys) {
    keys['startKey'] = item?.customKeys[0];
    keys['endKey'] = item?.customKeys[1];
  } else if (item?.keys) {
    keys['startKey'] = `q[${item.keys[0]}_gteq]`;
    keys['endKey'] = `q[${item.keys[1]}_lteq]`;
  } else {
    keys['startKey'] = `q[${item.key}_gteq]`;
    keys['endKey'] = `q[${item.key}_lteq]`;
  }

  return keys;
};

//------------------------- Advance Input Filter  --------------------

export const getAdvanceFilterKey = (item, keyType = FILTER_KEY_TYPES_SLUGS.EQUAL) => {
  return `f[${item.key}][${keyType}]`;
};

export const getSelectedAdvanceInputFilter = (filtersObj = {}, item = {}) => {
  const selectFilterKey = FILTER_KEY_TYPES_SLUGS_ARR.find(
    (keyType) => !!filtersObj?.[getAdvanceFilterKey(item, keyType)],
  );
  if (selectFilterKey) {
    return {
      key: getAdvanceFilterKey(item, selectFilterKey),
      value: filtersObj?.[getAdvanceFilterKey(item, selectFilterKey)],
    };
  }

  return {
    key: null,
    value: null,
  };
};

export const getCurrentFilterKeyOption = (item, currentKey = '') => {
  return FILTER_TYPES_OPTIONS.find((option) => {
    return (
      currentKey === getAdvanceFilterKey(item, option.value) &&
      (!!option?.defaultValue ? item?.selectedValue === option.defaultValue : true)
    );
  });
};
